import React from 'react';
import { ImageCarouselBlockStyles as S } from './ImageCarouselBlock.styles';
import ImageCarousel from '@stories/Widgets/ImageCarousel/ImageCarousel';
const ImageCarouselBlock = ({ data }) => {
    return (React.createElement(S.Container, null,
        React.createElement(ImageCarousel, { ...data })));
};
export default ImageCarouselBlock;
